import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import PaymentSetComponent from 'src/components/views/Setting/PaymentSetPage';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isAgent, userInfo, isDomestic }, locationState: { locations } }: IStoreState) => ({
  isAgent,
  userInfo,
  isDomestic,
  locations,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSetComponent);



// WEBPACK FOOTER //
// ./src/containers/PaymentSet.ts